<template>
  <div class="introduce">
    <div class="title">INTRODUCTION</div>
    <div class="introduceContent">
      <div class="description">
        <div class="enName">Sanlin Sino-Thai (Xiamen) Enterprise Co.,Ltd.</div>
        <div class="chName">三麟中泰（厦门）实业有限公司</div>
        <div class="text">
          Sanlin Sino-Thai (Xiamen) Enterprise Co.,Ltd. is a joint venture led by investors from China and technology from Thailand Century Food Group.
        </div>
        <div class="text">
          Sanlin China, headquartered in Xiamen, a beautiful coastal city known as the hometown of overseas Chinese, has set up supply chain centers in Shanghai, Guangzhou, Tianjin, Wuhan and Chengdu.
        </div>
        <div class="text">
          We are committed to exploring a new frontier in the global health and wellness food, and focusing on constructing a competitive supply chain system between China and Thailand to provide worldwide consumers with fashionable, affordable, and high-quality products .
        </div>
      </div>
      <div class="map">
        <img src="../../assets/images/ourStory/map.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduce",
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.introduce{
  .title{
    font-size: 34px;
    font-weight: 500;
    border-bottom: 3px solid #000000;
    margin: 0 40px;
  }
  .introduceContent{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    color: #3D3D3D;
    margin: 0 40px;
    margin-top: 90px;
    .description{
      width: 400px;
      .enName{
        font-size: 18px;
        font-weight: normal;
      }
      .chName{
        font-size: 28px;
        font-weight: 500;
      }
      .text{
        margin-top: 27px;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}
</style>